import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import { getIntlValidLocale } from '@app/helpers/locale';
import type { AppTheme } from '@app/styles/theme';

import { getButtonStyles } from '../Button';
import messages from './RetailerButton.messages';

export const RetailerButton = () => {
  const { language } = useParams<{
    language: string;
  }>();

  return (
    <a
      href={`/${getIntlValidLocale(language)}/company/resellers`}
      css={(theme: AppTheme) => getButtonStyles({ type: 'white', theme })}
      data-testid="retailer-button"
    >
      <FormattedMessage {...messages.findDealer} />
    </a>
  );
};
